// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2ANKw","footer":"styles_footer__1_qeZ","passCodeTooltip":"styles_passCodeTooltip__1kaSH"};